exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.notification-container[data-v-59179bc2] {\n    top: -30px;\n    left: -15px;\n}\n", ""]);

